import { map } from 'lodash';
import { type AnyAction } from 'redux';
import { resolveId } from '@wix/communities-blog-client-common';

import { FETCH_RECENT_POSTS_SUCCESS } from '../../post-page/actions/fetch-recent-posts';

type RecentPostsIdsState = Record<string, string[]>;

export default function recentPostsIdsReducer(
  state: RecentPostsIdsState = {},
  { type, payload, meta }: AnyAction = {} as AnyAction,
): RecentPostsIdsState {
  switch (type) {
    case FETCH_RECENT_POSTS_SUCCESS:
      return {
        ...state,
        [meta.postId]: map(payload, (post) => resolveId(post)),
      };
    default:
      return state;
  }
}
